import { Users, Ticket, BarChart3 } from "lucide-react";

/** Starter prompts shown on the empty-conversation hero. */
export const EXAMPLE_PROMPTS = [
  { icon: Users, text: "How many activated creators do I have?" },
  { icon: Ticket, text: "Which creators have I sent the promo code to?" },
  { icon: BarChart3, text: "Give me a status breakdown across all my campaigns" },
];
